// Shared FlowCloser brand mark — single source of truth for the icon used
// in the landing page, dashboard, top nav, login screen, etc.
//
// Colours come from the --blue-* CSS variables defined in app/globals.css,
// so the mark inherits the active palette wherever it is rendered.

export default function BrandMark({
  size = 28,
  className,
}: {
  size?: number
  className?: string
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block' }}
      className={className}
      aria-label="FlowCloser"
    >
      <defs>
        <linearGradient id="fc-bm" x1="0" x2="1" y1="0" y2="1">
          <stop offset="0" stopColor="var(--blue-950)" />
          <stop offset="1" stopColor="var(--blue-600)" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="14" fill="url(#fc-bm)" />
      <rect x="18" y="14" width="8" height="36" rx="3" fill="#fff" />
      <rect x="18" y="14" width="28" height="8" rx="3" fill="#fff" />
      <rect x="18" y="28" width="20" height="7" rx="3" fill="rgba(255,255,255,.6)" />
      <circle cx="46" cy="46" r="5" fill="var(--blue-500)" />
    </svg>
  )
}
